import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";

const ConfirmationDialogue = ({ isOpen, title, dialogueText, handleCancel, handleConfirm, confirmLabel, cancelLabel }) => {
  return (
    <Dialog open={isOpen} onClose={handleCancel}>
      <DialogTitle>{title ? title : "Unsaved Changes"}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {dialogueText
            ? dialogueText
            : "You have unsaved changes. Are you sure you want to leave this page? All your changes will be lost."}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          {cancelLabel ? cancelLabel : "Cancel"}
        </Button>
        <Button onClick={handleConfirm} sx={{
          color: '#A62B23'
        }}
          autoFocus>
          {confirmLabel ? confirmLabel : "Leave"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialogue;
